module.exports = __webpack_public_path__ + "static/c8h-logo-c13668dc8a5ec3adb4ab2c2345f6d32c.png";